import React from "react";
var DematCharges = function (props) {
    // const DematTable = [
    //   {
    //     title: "Yearly MaintananceCharges",
    //     value: <>0.00</>,
    //   },
    //   {
    //     title: "Activation Charge",
    //     value: <>Nil</>,
    //   },
    //   {
    //     title: "Inter Depository Sell Specified A/c",
    //     value: <>0.00 + (P_e.ADPAmt*0.00)</>,
    //   },
    //   {
    //     title: "Inter Depository Buy Specified A/c",
    //     value: <>0.00</>,
    //   },
    //   {
    //     title: "Off market Debit to Specified A/c",
    //     value: <>0.00 + (P_e.ADPAmt*0.00)</>,
    //   },
    //   {
    //     title: "Off Market Debit To CM",
    //     value: <>0.00 + (P_e.ADPAmt*0.00)</>,
    //   },
    //   {
    //     title: "Off Market Debit To Specified CM",
    //     value: <>0.00 + (P_e.ADPAmt*0.00)</>,
    //   },
    //   {
    //     title: "Pledge Invocation Charges",
    //     value: <>0.00 + (P_e.ADPAmt*0.00)</>,
    //   },
    //   {
    //     title: "Dematerialization",
    //     value: <>30.00 + (2.00*No Of Certificates)</>,
    //   },
    //   {
    //     title: "Rematerialization",
    //     value: <>Nil</>,
    //   },
    // ];
    var _a, _b, _c;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", null,
            React.createElement("div", { className: "dematcharges-tile-head DMSan_16_700 txt_blackOne1" }, "Demat Charges Structure"),
            React.createElement("div", { className: "flexJustifySpaceBetween dematcharges-head" },
                React.createElement("div", { className: "DMSansMedium_12_500 txt_primaryGrey" }, "Charge type"),
                React.createElement("div", { className: "DMSansMedium_12_500 txt_primaryGrey" }, "Amount(Rs)")),
            React.createElement("div", { className: "demattable-body" }, ((_a = props === null || props === void 0 ? void 0 : props.allDpDetailsByDPId) === null || _a === void 0 ? void 0 : _a.clientDPType) && ((_b = props === null || props === void 0 ? void 0 : props.allDpDetailsByDPId) === null || _b === void 0 ? void 0 : _b.clientDPType.length) > 0 && ((_c = props === null || props === void 0 ? void 0 : props.allDpDetailsByDPId) === null || _c === void 0 ? void 0 : _c.clientDPType.map(function (data) {
                return (React.createElement("div", { className: "flexJustifySpaceBetween demattable-body-block" },
                    React.createElement("div", { className: "DMSansMedium_12_500 txt_blackOne1" }, data.type),
                    React.createElement("div", { className: "DMSanM_14_500 txt_blackOne1 taRight" }, data.amount)));
            }))))));
};
export default DematCharges;
